import { Arrows } from '@ad-lucy/components/nav/NavigationArrow/types';
import {
  CREATIVE_TYPE,
  type CreativesConfig,
  defaultCreativesConfig,
} from '@ad-lucy/config/creatives';
import { GlobalPayout } from '@ad-lucy/utils/types';
import { lazy } from 'react';
import type { componentNames } from './componentNames';

type VVCreativesConfigComponentKeys = (typeof componentNames)[number];

export const vvConfig: CreativesConfig<VVCreativesConfigComponentKeys> = {
  ...defaultCreativesConfig,
  id: CREATIVE_TYPE.VV,
  name: 'VerticalVideo Ad',
  settings: {
    ...defaultCreativesConfig.settings,
    forceGlobalPayout: GlobalPayout.NO_PAYOUT_ON_HOVER,
  },
  navigation: {
    ...defaultCreativesConfig.navigation,
    arrows: Arrows.SIMPLE,
    transition: 'fade',
    trackInitialViewOnlyIfInActiveTab: true,
  },
  components: {
    headerLogo: {
      ...defaultCreativesConfig.components.headerLogo,
    },
    closeAd: {
      ...defaultCreativesConfig.components.closeAd,
    },
    vastVideoXL: {
      ...defaultCreativesConfig.components.vastVideoXL,
      defaults: {
        ...defaultCreativesConfig.components.vastVideoXL.defaults,
        controls: false,
      },
    },
    modal: {
      ...defaultCreativesConfig.components.modal,
    },
    // FOOTER
    socialFlyoutBar: {
      ...defaultCreativesConfig.components.socialFlyoutBar,
    },
    socialMediaBar: {
      ...defaultCreativesConfig.components.socialMediaBar,
    },
    socialmedia: {
      ...defaultCreativesConfig.components.socialmedia,
    },
    socialmediaFooter: {
      ...defaultCreativesConfig.components.socialmediaFooter,
    },
    stickyCTA: {
      ...defaultCreativesConfig.components.stickyCTA,
    },
    terms: {
      ...defaultCreativesConfig.components.terms,
    },
    copyright: {
      ...defaultCreativesConfig.components.copyright,
    },
    mediaControls: {
      ...defaultCreativesConfig.components.mediaControls,
      wrapper: lazy(
        () => import('@ad-lucy/vv/components/styledBuilderComponents/StyledMediaControls'),
      ),
    },
    sharingButtonFooter: {
      ...defaultCreativesConfig.components.sharingButtonFooter,
      wrapper: lazy(
        () => import('@ad-lucy/vv/components/styledBuilderComponents/StyledSharingButtonFooter'),
      ),
    },
  },
};
